import React, { ReactNode } from "react";
import TopBuyer from "@components/category/topBuyer/TopBuyer";
import CategoryTab from "@components/category/categoryTab";
import Breadcrumb from "@components/shared/breadcrumb";
import CategoryIntro from "@components/category/categoryIntro";
import { Fade } from "react-awesome-reveal";
import { GQLUrls } from "@gql/types/gql";
import {
    ICategoryPageSharedProps,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
import style from "./style.module.scss";
import { replaceDkis, resolveURL } from "@lib/sharedUtils";
import { useQuery } from "@tanstack/react-query";

const CategoryTemplate = ({ children }: { children: ReactNode }) => {
    const { data: sharedProps } = useQuery<ICategoryPageSharedProps>([
        "categoryPageSharedProps",
    ]);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { dkis, url } = sharedProps ?? {};

    const arr = [
        {
            label: `${translate(
                translations,
                "several_general_breadcrumb_home",
            )}`,
            link: "/",
            isActive: true,
            showOnMobile: true,
        },

        {
            label: replaceDkis(resolveURL(url as GQLUrls) ?? "", dkis),
            link: `${resolveURL(url as GQLUrls)}`,
            isActive: true,
            showOnMobile: true,
        },
    ];

    return (
        <div>
            <section className="max-w-7xl mx-auto px-5 ">
                <Breadcrumb arr={arr} />

                <Fade duration={1200} triggerOnce>
                    <div className={`mt-8 mb-8 ${style["flexStyle"]}`}>
                        <CategoryIntro />
                        <TopBuyer />
                    </div>
                </Fade>
                <CategoryTab />
                {children}
            </section>
        </div>
    );
};

export default CategoryTemplate;
